document.addEventListener('DOMContentLoaded', () => {
  const policyRouteMap = {
    '/policies/terms-of-service': '/pages/terms-of-service',
    '/policies/privacy-policy': '/pages/privacy-policy'
  };

  document.querySelectorAll('a[href]').forEach((link) => {
    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin || !policyRouteMap[url.pathname]) return;
      link.setAttribute('href', `${policyRouteMap[url.pathname]}${url.search}${url.hash}`);
    } catch (error) {
      // Leave malformed or non-HTTP links unchanged.
    }
  });

  const positionStickyBackLinks = () => {
    document.querySelectorAll('[data-fty-back-sticky]').forEach((link) => {
      link.classList.remove('is-stuck');
      link.style.removeProperty('--fty-back-top');
      link.style.removeProperty('--fty-back-left');
      const rect = link.getBoundingClientRect();
      link.style.setProperty('--fty-back-top', `${Math.max(12, rect.top)}px`);
      link.style.setProperty('--fty-back-left', `${Math.max(10, rect.left)}px`);
      link.classList.add('is-stuck');
    });
  };

  positionStickyBackLinks();
  window.addEventListener('resize', positionStickyBackLinks, { passive: true });

  const alignFixedHeaderUtilities = () => {
    const dateTime = Array.from(document.querySelectorAll('.date-time-container')).find((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    if (!dateTime) return;

    const dateRect = dateTime.getBoundingClientRect();
    const centerY = dateRect.top + (dateRect.height / 2);
    document.querySelectorAll('.fty-global-cart-utility, .fty-back-link--fixed, .global-menu, .fty-global-join-link').forEach((element) => {
      const rect = element.getBoundingClientRect();
      const height = rect.height || 45;
      element.style.top = `${Math.max(12, centerY - (height / 2))}px`;
    });
  };

  alignFixedHeaderUtilities();
  window.addEventListener('load', alignFixedHeaderUtilities, { once: true });
  window.addEventListener('resize', alignFixedHeaderUtilities, { passive: true });

  document.querySelectorAll('[data-fty-back]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      let sameOriginReferrer = false;
      try {
        sameOriginReferrer = Boolean(document.referrer) && new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        sameOriginReferrer = false;
      }

      if (sameOriginReferrer && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = link.getAttribute('href') || '/';
      }
    });
  });

  const popup = document.querySelector('[data-popup]');
  const overlay = document.querySelector('[data-popup-overlay]');
  const closeButton = document.querySelector('[data-popup-close]');
  let previouslyFocused = null;

  if (!popup || !overlay) return;

  const openPopup = (event) => {
    if (event) event.preventDefault();
    previouslyFocused = event && event.currentTarget ? event.currentTarget : document.activeElement;
    popup.classList.add('active');
    overlay.classList.add('active');
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeButton) requestAnimationFrame(() => closeButton.focus());
  };

  const closePopup = () => {
    popup.classList.remove('active');
    overlay.classList.remove('active');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
  };

  document.querySelectorAll('[data-join-fty]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const inlineEmail = document.getElementById('JoinFTYEmail');
      if (inlineEmail) {
        event.preventDefault();
        inlineEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
        requestAnimationFrame(() => inlineEmail.focus());
        return;
      }
      openPopup(event);
    });
  });

  if (closeButton) closeButton.addEventListener('click', closePopup);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('active')) closePopup();
    if (event.key !== 'Tab' || !popup.classList.contains('active')) return;

    const focusableItems = Array.from(popup.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
    if (!focusableItems.length) return;

    const firstItem = focusableItems[0];
    const lastItem = focusableItems[focusableItems.length - 1];
    if (event.shiftKey && document.activeElement === firstItem) {
      event.preventDefault();
      lastItem.focus();
    } else if (!event.shiftKey && document.activeElement === lastItem) {
      event.preventDefault();
      firstItem.focus();
    }
  });
});
